export default __webpack_public_path__ + "static/media/arq-sistemas.1f5ebf3a.png";